export default {
  name: 'ShUserAvatar',

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    avatar: {
      type: String,
    },
  },
};
